import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap'

import Lang from 'Lang/General'

const DeletePromptModal = ({
  showPromptModal,
  onClickYes,
  onClickNo,
  content,
  selectedLanguage
}) => {
  return (
    <Modal
      isOpen={ showPromptModal }
      size={ 'md' }>
      <ModalHeader>{ Lang[ 'CONFIRMATION_MODAL' ][ selectedLanguage ] }</ModalHeader>
      <ModalBody>
        { content }
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary"
          onClick={ onClickYes }>{ Lang[ 'YES' ][ selectedLanguage ] }</Button>
        <Button 
          color="danger"
          onClick={ onClickNo }>{ Lang[ 'NO' ][ selectedLanguage ] }</Button>
      </ModalFooter>
    </Modal>
  )
}

export default DeletePromptModal